'use strict';
(() => {
  const payload = document.getElementById('samo-store-data');
  if (!payload) return;
  const config = JSON.parse(payload.textContent);
  const catalog = config.catalog;
  const root = config.root.endsWith('/') ? config.root : config.root + '/';
  const query = selector => document.querySelector(selector);
  const all = selector => Array.from(document.querySelectorAll(selector));
  const money = (cents, currency = config.currency) => new Intl.NumberFormat(config.locale || 'en-US', {style:'currency', currency:currency || 'EUR', maximumFractionDigits:2}).format(cents / 100);
  const escape = value => String(value ?? '').replace(/[&<>"']/g, character => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[character]));
  function safeUrl(value, fallback = '') {
    try { const url = new URL(value, location.origin); return ['https:','http:'].includes(url.protocol) ? url.href : fallback; } catch { return fallback; }
  }
  let selected = 'ivory';
  let secondary = 'ivory';
  let quantity = 1;
  let cart = null;
  let busy = false;
  let restoreFocus = null;
  let toastTimer = 0;
  const productDialog = query('#product-dialog');
  const cartDialog = query('#cart-dialog');
  function toast(message) {
    const element = query('#toast');
    clearTimeout(toastTimer);
    element.textContent = message;
    element.classList.add('visible');
    toastTimer = setTimeout(() => element.classList.remove('visible'), 6000);
  }
  function showDialog(dialog) {
    restoreFocus = document.activeElement;
    all('dialog[open]').forEach(other => other.close());
    dialog.showModal();
  }
  all('dialog').forEach(dialog => {
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => {
      if (restoreFocus?.isConnected && !query('dialog[open]')) restoreFocus.focus();
    });
  });
  async function request(endpoint, body) {
    const options = {credentials:'same-origin', headers:{Accept:'application/json'}, cache:'no-store'};
    if (body !== undefined) {
      options.method = 'POST';
      options.headers['Content-Type'] = 'application/json';
      options.body = JSON.stringify(body);
    }
    const response = await fetch(root + endpoint, options);
    let data;
    try { data = await response.json(); } catch { throw new Error('Shopify could not respond. Please open the full bag and try again.'); }
    if (!response.ok) throw new Error(data.description || (typeof data.message === 'string' && data.message) || 'The bag could not be updated. Please try again.');
    return data;
  }
  function setBusy(value) {
    busy = value;
    cartDialog.setAttribute('aria-busy', String(value));
    query('#checkout-button').disabled = value || !config.salesEnabled;
    query('#add-to-bag').disabled = value || !canAdd();
  }
  function choices() {
    if (quantity > 1 && secondary !== selected) return {[selected]:quantity - 1,[secondary]:1};
    return {[selected]:quantity};
  }
  function canAdd() {
    return config.salesEnabled && Object.keys(choices()).every(id => catalog[id]?.connected && catalog[id].available);
  }
  function updateQuantity() {
    const item = catalog[selected];
    query('#product-quantity').textContent = quantity;
    query('#qty-minus').disabled = quantity === 1 || busy;
    query('#qty-plus').disabled = quantity >= 10 || busy;
    query('#single-bundle-price').textContent = money(item.price);
    query('#duo-bundle-price').textContent = money(Math.round((item.price + catalog[secondary].price) * .85));
    all('[data-bundle]').forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.bundle) === quantity)));
    query('#second-design-label').hidden = quantity < 2;
    query('#second-design').value = secondary;
    const subtotal = Object.entries(choices()).reduce((sum,[id,count]) => sum + catalog[id].price * count,0);
    const estimate = config.duoEnabled && quantity >= 2 ? Math.round(subtotal * .85) : subtotal;
    const add = query('#add-to-bag');
    add.textContent = busy ? 'Opening checkout…' : `Buy now · ${money(estimate)} →`;
    add.disabled = busy || !canAdd();
    query('#product-status').textContent = !config.salesEnabled ? 'Shopping opens soon. This is a styling preview.'
      : !item.connected ? 'This design is not yet available to purchase.'
      : !Object.keys(choices()).every(id => catalog[id].available) ? 'A selected design is sold out. Choose another design.'
      : config.duoEnabled && quantity >= 2 ? 'Estimated item total. Shopify confirms the actual offer in your bag.'
      : 'Free US shipping. Taxes calculated at checkout.';
  }
  function selectProduct(id) {
    if (!catalog[id]) return;
    selected = id;
    if (quantity === 1) secondary = id;
    const item = catalog[id];
    query('#product-title').textContent = item.name;
    query('#product-description').textContent = item.description;
    query('#detail-image').src = safeUrl(item.image);
    query('#detail-image').alt = item.name;
    query('#product-current-price').textContent = money(item.price);
    const reference = query('#product-reference-price');
    reference.hidden = !(item.connected && item.compareAtPrice > item.price);
    reference.textContent = reference.hidden ? '' : money(item.compareAtPrice);
    query('#product-price-currency').textContent = `${config.currency} / each`;
    const link = query('#full-product-link');
    link.hidden = !item.connected;
    if (item.connected) link.href = safeUrl(`${item.url}?variant=${item.variantId}`);
    all('[data-swatch]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.swatch === selected)));
    const gallery = query('.gallery-thumbs');
    gallery.replaceChildren();
    [item.image, config.hero, config.holiday].forEach((src,index) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.setAttribute('aria-label', ['View selected design','View warm lifestyle photo','View holiday photo'][index]);
      button.setAttribute('aria-pressed', String(index === 0));
      const image = document.createElement('img');
      image.src = safeUrl(src); image.alt = ''; button.append(image);
      button.addEventListener('click', () => {
        query('#detail-image').src = safeUrl(src);
        query('#detail-image').alt = index === 0 ? item.name : 'Samo Confort — original AI styling concept';
        gallery.querySelectorAll('button').forEach(other => other.setAttribute('aria-pressed', String(other === button)));
      });
      gallery.append(button);
    });
    updateQuantity();
  }
  for (const [id,item] of Object.entries(catalog)) {
    const button = document.createElement('button');
    button.type = 'button'; button.className = id; button.dataset.swatch = id;
    button.title = item.name; button.setAttribute('aria-label', item.name);
    button.setAttribute('aria-pressed', String(id === selected));
    query('#swatches').append(button);
    query('#second-design').add(new Option(item.name,id));
  }
  function renderCart(data) {
    cart = data;
    const currency = data.currency || config.currency;
    all('.bag-count').forEach(element => { element.textContent = data.item_count; });
    all('[data-open-cart]').forEach(button => button.setAttribute('aria-label', `Shopping bag, ${data.item_count} items`));
    const content = query('#cart-items');
    content.replaceChildren();
    query('#cart-summary').hidden = data.item_count === 0;
    if (!data.item_count) {
      content.innerHTML = `<div class="empty-bag"><span aria-hidden="true">♡</span><h3>A little empty. For now.</h3><p>Find a cozy layer to make it yours.</p><a class="button primary" href="${escape(root)}#collection">Explore the collection ↗</a></div>`;
      return;
    }
    data.items.forEach(item => {
      const known = Object.values(catalog).find(style => style.variantId === item.variant_id);
      const row = document.createElement('article');
      row.className = 'cart-row';
      const image = safeUrl(item.image || known?.image || config.hero);
      const title = item.product_title || item.title;
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      row.innerHTML = `<img src="${escape(image)}" alt="${escape(title)}" width="80" height="100"><div><h3>${escape(title)}</h3><p>${escape(variant)}${variant ? ' · ' : ''}${escape(money(item.final_price,currency))} each</p><div class="stepper"><button type="button" data-cart-action="decrease" aria-label="Decrease ${escape(title)} quantity">−</button><output aria-label="${escape(title)} quantity">${item.quantity}</output><button type="button" data-cart-action="increase" aria-label="Increase ${escape(title)} quantity">+</button></div><button type="button" class="cart-remove" data-cart-action="remove" aria-label="Remove ${escape(title)}">Remove</button></div><strong>${escape(money(item.final_line_price,currency))}</strong>`;
      row.querySelectorAll('[data-cart-action]').forEach(button => button.addEventListener('click', async () => {
        if (busy) return;
        const action = button.dataset.cartAction;
        const amount = action === 'remove' ? 0 : item.quantity + (action === 'increase' ? 1 : -1);
        setBusy(true);
        try { renderCart(await request('cart/change.js',{id:item.key,quantity:amount})); }
        catch (error) { toast(error.message); await refreshCart().catch(() => {}); }
        finally { setBusy(false); }
      }));
      content.append(row);
    });
    query('#cart-subtotal').textContent = money(data.original_total_price,currency);
    query('#cart-savings').textContent = `−${money(data.total_discount,currency)}`;
    query('#cart-saving-row').hidden = data.total_discount === 0;
    query('#cart-total').textContent = money(data.total_price,currency);
    query('#cart-currency').textContent = currency;
    const eligibleIds = new Set(Object.values(catalog).filter(item => item.connected).map(item => item.variantId));
    const eligibleCount = data.items.reduce((sum,item) => sum + (eligibleIds.has(item.variant_id) ? item.quantity : 0),0);
    query('#duo-status').textContent = !config.duoEnabled ? 'Your bag uses actual Shopify prices.'
      : eligibleCount < 2 ? 'Choose two eligible Samo designs for the Cozy Duo offer.'
      : data.total_discount > 0 ? 'Your Shopify discounts are reflected below.'
      : 'The Cozy Duo discount has not been applied. Please check the offer before paying.';
  }
  async function refreshCart() {
    const data = await request('cart.js');
    renderCart(data);
    return data;
  }
  async function addItems(items) {
    if (busy || !config.salesEnabled) return;
    setBusy(true);
    try {
      await request('cart/add.js', {items});
      location.assign(root + 'checkout');
    } catch (error) {
      toast(error.message);
      setBusy(false);
      updateQuantity();
    }
  }
  function filterProducts(category) {
    all('[data-filter]').forEach(button => {
      const active = button.dataset.filter === category;
      button.classList.toggle('active',active); button.setAttribute('aria-pressed',String(active));
    });
    all('.product-card').forEach(card => { card.hidden = category !== 'all' && card.dataset.category !== category; });
  }
  document.addEventListener('click', async event => {
    const button = event.target.closest('button,a');
    if (!button) return;
    if (button.matches('[data-close-dialog]')) button.closest('dialog').close();
    if (button.matches('[data-product]')) { quantity = 1; selectProduct(button.dataset.product); showDialog(productDialog); }
    if (button.matches('[data-swatch]')) selectProduct(button.dataset.swatch);
    if (button.matches('[data-bundle]')) { quantity = Number(button.dataset.bundle); updateQuantity(); }
    if (button.id === 'qty-minus') { quantity = Math.max(1,quantity - 1); updateQuantity(); }
    if (button.id === 'qty-plus') { quantity = Math.min(10,quantity + 1); updateQuantity(); }
    if (button.id === 'add-to-bag' && canAdd()) {
      const merged = new Map();
      for (const [id,count] of Object.entries(choices())) {
        const variantId = catalog[id].variantId;
        merged.set(variantId,(merged.get(variantId) || 0) + count);
      }
      await addItems(Array.from(merged,([id,quantity]) => ({id,quantity})));
    }
    if (button.matches('[data-open-cart]')) {
      showDialog(cartDialog);
      if (!cart) query('#cart-items').innerHTML = '<p>Loading your bag…</p>';
      try { await refreshCart(); } catch (error) {
        query('#cart-items').innerHTML = `<p>We could not load your bag. <a href="${escape(root)}cart">Open the full bag →</a></p>`;
        query('#cart-summary').hidden = true;
        toast(error.message);
      }
    }
    if (button.matches('[data-filter]')) filterProducts(button.dataset.filter);
    if (button.id === 'shop-holiday') { filterProducts('holiday'); query('#collection')?.scrollIntoView({behavior:'smooth'}); }
    if (button.id === 'build-duo') { quantity = 2; secondary = 'ivory'; selectProduct('ivory'); showDialog(productDialog); }
    if (button.matches('.menu-toggle')) {
      const nav = query('#mobile-navigation'); nav.hidden = !nav.hidden;
      button.setAttribute('aria-expanded',String(!nav.hidden)); button.setAttribute('aria-label',nav.hidden ? 'Open menu' : 'Close menu');
    }
    if (button.closest('#mobile-navigation') || button.closest('.empty-bag')) {
      query('#mobile-navigation').hidden = true;
      query('.menu-toggle')?.setAttribute('aria-expanded','false');
      query('.menu-toggle')?.setAttribute('aria-label','Open menu');
      if (button.closest('.empty-bag')) cartDialog.close();
    }
  });
  document.addEventListener('change', event => {
    if (event.target.id === 'second-design') { secondary = event.target.value; updateQuantity(); }
    if (event.target.matches('[data-native-variant]')) updateNativeProduct(event.target.closest('[data-native-product]'));
  });
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-native-product-form]');
    if (!form || !config.salesEnabled) return;
    event.preventDefault();
    const values = new FormData(form);
    const button = form.querySelector('[type=submit]');
    button.disabled = true;
    await addItems([{id:Number(values.get('id')),quantity:Number(values.get('quantity')) || 1}]);
    updateNativeProduct(form.closest('[data-native-product]'));
  });
  function updateNativeProduct(container) {
    if (!container) return;
    const data = JSON.parse(container.querySelector('[data-native-product-json]').textContent);
    const chosen = container.querySelector('[data-native-variant]').value;
    const variant = data.variants.find(item => String(item.id) === chosen);
    if (!variant) return;
    container.querySelector('[data-native-price]').textContent = money(variant.price);
    const reference = container.querySelector('[data-native-reference]');
    reference.hidden = !(variant.compare_at_price > variant.price);
    reference.textContent = reference.hidden ? '' : money(variant.compare_at_price);
    const add = container.querySelector('[type=submit]');
    add.disabled = !config.salesEnabled || !variant.available || busy;
    add.textContent = !config.salesEnabled ? 'Shopping opens soon' : variant.available ? 'Buy now →' : 'Sold out';
    const style = Object.values(catalog).find(item => item.variantId === variant.id);
    if (variant.featured_image?.src || style?.image) container.querySelector('[data-native-image]').src = safeUrl(variant.featured_image?.src || style.image);
  }
  function initializeScenery() {
    all('[data-price-style]').forEach(element => { if (catalog[element.dataset.priceStyle]) element.textContent = money(catalog[element.dataset.priceStyle].price); });
    const comparison = query('#compare-range');
    const frame = query('.compare-frame');
    if (comparison && !comparison.dataset.initialized) {
      comparison.dataset.initialized = 'true';
      function reveal(value) {
        const amount = Math.min(100,Math.max(0,Number(value)));
        comparison.value = String(amount); frame.style.setProperty('--reveal',`${amount}%`);
        comparison.setAttribute('aria-valuetext',`${amount} percent cold scene, ${100 - amount} percent cozy scene`);
        frame.querySelector('.before-label').style.opacity = amount < 15 ? '0' : '1';
        frame.querySelector('.after-label').style.opacity = amount > 85 ? '0' : '1';
        all('[data-compare]').forEach(button => button.setAttribute('aria-pressed',String(Number(button.dataset.compare) === amount)));
      }
      comparison.addEventListener('input',() => reveal(comparison.value));
      comparison.addEventListener('keydown',event => { if (['Home','End'].includes(event.key)) { event.preventDefault(); reveal(event.key === 'Home' ? 0 : 100); } });
      all('[data-compare]').forEach(button => button.addEventListener('click',() => reveal(button.dataset.compare)));
      reveal(50);
    }
    const dial = query('#heat-range');
    if (dial && !dial.dataset.initialized) {
      dial.dataset.initialized = 'true';
      const moods = ['Gentle','Snug','Cozy','Toasty','Cocoon','Full cozy'];
      const update = () => {
        const level = Number(dial.value), mood = moods[level - 1];
        query('#heat-number').textContent = level; query('#heat-description').textContent = mood; query('#warmth-mood').textContent = mood;
        dial.style.setProperty('--heat-fill',`${(level - 1) / 5 * 100}%`);
        query('.warmth-photo').style.setProperty('--cozy-glow',String(level / 6));
        dial.setAttribute('aria-valuetext',`Level ${level}: ${mood}. Visual demonstration, not actual product settings.`);
      };
      dial.addEventListener('input',update); update();
    }
    all('[data-native-product]').forEach(updateNativeProduct);
    if ('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches && !window.Shopify?.designMode) {
      document.documentElement.classList.add('motion-ready');
      const observer = new IntersectionObserver(entries => entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); } }),{threshold:.08});
      all('.section-top,.product-card,.duo-banner,.story-copy,.story-media,.ritual-grid article,.holiday-copy,.holiday-image,.warmth-copy,.warmth-photo,.feature-mosaic article,.review-heading,.return-promise').filter(element => !element.dataset.observed).forEach(element => { element.dataset.observed = 'true'; element.classList.add('reveal'); observer.observe(element); });
    }
  }
  if ('IntersectionObserver' in window && query('.mobile-buy') && query('.hero')) {
    const visible = {hero:true,footer:false};
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => { visible[entry.target.tagName === 'FOOTER' ? 'footer' : 'hero'] = entry.isIntersecting; });
      query('.mobile-buy').hidden = visible.hero || visible.footer;
    },{threshold:.05});
    observer.observe(query('.hero')); observer.observe(query('footer'));
  }
  document.addEventListener('shopify:section:load', initializeScenery);
  document.addEventListener('shopify:section:select', event => { event.target.querySelectorAll('.reveal').forEach(element => element.classList.add('is-visible')); });
  initializeScenery();
  selectProduct('ivory');
  refreshCart().catch(() => { /* The full Shopify cart remains available during network outages. */ });
})();

